<template>
  <div>
    <el-card class="box-card">
      <div 
        slot="header" 
        class="clearfix">
        <span>顶部首图</span>
      </div>
      <ul class="gallery">
        <li
          v-for="(item, index) in topFiles"
          :key="item.id"
          @click="dialogShow(3, item.id, index)"
        >
          <img
            :src="
              (item.icon_url
                ? item.icon_url
                : 'http://img.yimutian.com/crm/5c13710d6400816b26170c746c233ad8.png')
                | aspectFill(375, 320)
            "
          >
          <span 
            class="del_btn" 
            @click.stop="deleteItem(item.id)" />
        </li>
        <li
          v-if="topFiles.length == 0"
          style="
            border: 1px dashed #b7b7b7;
            cursor: pointer;
            margin-right: 0;
            vertical-align: top;
            height: 90px;
          "
        >
          <div 
            class="upload_area" 
            @click="dialogShow(3)">
            <img
              src="http://img.yimutian.com/crm/5c13710d6400816b26170c746c233ad8.png"
            >
          </div>
        </li>
      </ul>
    </el-card>
    <el-card class="box-card">
      <div 
        slot="header" 
        class="clearfix">
        <span>金刚区</span>
      </div>
      <ul class="gallery">
        <!-- <li>
          <img
            src="//img.yimutian.com/crm/5fa8fc07b827730a883de48500b400b4.png"
          >
          <p>产地天气</p>
        </li> -->
        <li
          v-for="(file, idx) in files"
          :key="file.id"
          @click="dialogShow(1, file.id, idx)"
        >
          <img :src="file.icon_url | aspectFill(200, 180)" >
          <span 
            class="del_btn" 
            @click.stop="deleteItem(file.id)" />
          <p>{{ file.name }}</p>
        </li>
        <li 
          v-for="item in maxnum" 
          :key="item.id" 
          class="jingangitem">
          <div 
            class="upload_area" 
            @click="dialogShow(1)">
            <img
              src="http://img.yimutian.com/crm/5c13710d6400816b26170c746c233ad8.png"
            >
          </div>
        </li>
      </ul>
    </el-card>
    <el-card class="box-card">
      <div 
        slot="header" 
        class="clearfix">
        <span>Banner广告位</span>
      </div>
      <ul class="gallery">
        <li
          v-for="(item, index) in bannerFiles"
          :key="item.id"
          @click="dialogShow(4, item.id, index)"
        >
          <img
            :src="
              (item.icon_url
                ? item.icon_url
                : 'http://img.yimutian.com/crm/5c13710d6400816b26170c746c233ad8.png')
                | aspectFill(350, 300)
            "
          >
          <span 
            class="del_btn" 
            @click.stop="deleteItem(item.id)" />
        </li>
        <li
          v-if="bannerFiles.length == 0"
          style="
            border: 1px dashed #b7b7b7;
            cursor: pointer;
            margin-right: 0;
            vertical-align: top;
            height: 90px;
          "
        >
          <div 
            class="upload_area" 
            @click="dialogShow(4)">
            <img
              src="http://img.yimutian.com/crm/5c13710d6400816b26170c746c233ad8.png"
            >
          </div>
        </li>
      </ul>
    </el-card>
    <el-card class="box-card">
      <div 
        slot="header" 
        class="clearfix">
        <span>新闻媒体区</span>
      </div>
      <ul class="gallery">
        <draggable 
          v-model="goodFiles" 
          style="display: flex"
          group="people" 
          @end="drag">
          <li
            v-for="(file, index) in goodFiles"
            :key="file.id"
            @click="dialogShow(5, file.id, index)"
          >
            <img :src="file.icon_url | aspectFill(110, 110)" >
            <span 
              class="del_btn" 
              @click.stop="deleteItem(file.id)" />
            <div class="galleryitem">
              <h5>{{ file.name }}</h5>
              <p>
                {{ file.product }}
              </p>
            </div>
          </li>
        </draggable>
        <li
          style="
            border: 1px dashed #b7b7b7;
            cursor: pointer;
            margin-right: 0;
            vertical-align: top;
            height: 90px;
          "
        >
          <div 
            class="upload_area" 
            @click="dialogShow(5)">
            <img
              src="http://img.yimutian.com/crm/5c13710d6400816b26170c746c233ad8.png"
            >
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 弹框 -->
    <el-dialog
      :visible.sync="dialogshow"
      :title="dialogname + '配置'"
      center
      @close="clearform"
    >
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        label-position="right"
      >
        <el-form-item
          v-if="areatype == 1"
          :rules="[
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 1,
              max: 5,
              message: '长度在 1 到 5 个字符',
              trigger: 'blur',
            },
          ]"
          label="名称:"
          prop="name"
        >
          <el-input
            v-model="form.name"
            :placeholder="areatype != 5 ? '请输入名称' : '请输入标题'"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          v-if="areatype == 5"
          :rules="[
            { required: true, message: '请输入名称', trigger: 'blur' },
            { max: 12, message: '长度在12个字符内', trigger: 'blur' },
          ]"
          label="标题:"
          prop="name"
        >
          <el-input
            v-model="form.name"
            :placeholder="areatype != 5 ? '请输入名称' : '请输入标题'"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item 
          v-if="areatype == 5" 
          label="摘要:" 
          prop="abstract">
          <el-input
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="form.abstract"
            label="摘要:"
            type="textarea"
            placeholder="请输入摘要"
          />
        </el-form-item>

        <el-form-item 
          label="图标:" 
          prop="icon_url">
          <ymt-file-upload
            :files="imgfiles"
            refname="uploadimg"
            @addFiles="addfiles"
            @delFiles="deletefiles"
          />
          <p class="tip">建议尺寸:{{ tipname }}像素</p>
        </el-form-item>
        <el-form-item 
          v-if="areatype != 3" 
          label="跳转链接:" 
        >
          <!-- prop="target_url" -->
          <el-input 
            v-model="form.target_url" 
            autocomplete="off" />
        </el-form-item>
      </el-form>
      <div 
        slot="footer" 
        class="dialog-footer">
        <el-button @click="submit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import YmtFileUpload from '../components/YmtFileUpload'
import { mapState } from 'vuex'
import Vue from 'vue'
import { merchant } from '@/api'
import { Message } from 'element-ui'
import configDataMap from '../config/other-config'

export default {
  name: 'AuthMessage',
  components: {
    draggable,
    YmtFileUpload,
  },
  data() {
    return {
      files: [
        //金刚区
      ],
      dialogshow: false,
      form: {
        name: '',
        icon_url: '',
        target_url: '',
        abstract: '',
      },
      goodFiles: [],
      topFiles: [],
      dialogname: '金刚区',
      areatype: 1,
      imgfiles: [],
      rules: {
        abstract: [
          { required: true, message: '请输入摘要', trigger: 'blur' },
          { max: 20, message: '摘要20字符以内', trigger: 'blur' },
        ],
        icon_url: [
          { required: true, message: '请选择图片', trigger: 'change' },
        ],
        target_url: [
          { required: true, message: '请输入跳转链接', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (value.indexOf('http') !== -1) {
                if (
                  /^(http|https):\/\/([\w-]+\.)+[\w-]+(\/?[\w-./?%&=]*)?$/.test(
                    value
                  ) === false
                ) {
                  callback(new Error('请输入正确的url'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
      bannerFiles: [],
      updateid: 0,
      tipname:''
    }
  },
  computed: {
    maxnum() {
      return 6 - this.files.length
    },
    produceId() {
      return configDataMap[this.$route.params.place].produce
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    dialogShow(areatype, id, listindex) {
      // areatype 区域类型 1：金刚区 2: 农资农机 3：顶部首页 4: banner广告位 5：新闻媒体区
      // listindex 前两个固定不变但可以修改
      this.areatype = areatype
      if (id) {
        this.updateid = id
      }
      if (areatype === 1) {
        this.dialogname = '金刚区'
        this.tipname = '375 * 230'
        if (listindex == 0 || listindex) {
          this.form = JSON.parse(JSON
            .stringify(this.files[listindex])) 
          this.imgfiles = [
            {
              id: this.files[listindex].id,
              icon_url: this.files[listindex].icon_url,
            },
          ]
        }
      }
      if (areatype === 3) {
        this.dialogname = '顶部首页'
        this.tipname = '1125 * 804'
        if (listindex == 0 || listindex) {
          this.form = JSON.parse(JSON
            .stringify(this.topFiles[listindex])) 
          this.imgfiles = [
            {
              id: this.topFiles[listindex].id,
              icon_url: this.topFiles[listindex].icon_url,
            },
          ]
        }
      }
      if (areatype === 4) {
        this.dialogname = 'Banner广告位'
        this.tipname = '1050 * 300'
        if (listindex == 0 || listindex) {
          this.form = JSON.parse(JSON
            .stringify(this.bannerFiles[listindex])) 
          this.imgfiles = [
            {
              id: this.bannerFiles[listindex].id,
              icon_url: this.bannerFiles[listindex].icon_url,
            },
          ]
        }
      }
      if (areatype === 5) {
        this.dialogname = '新闻媒体区'
        this.tipname = '330 * 210'
        if (listindex == 0 || listindex) {
          this.form = JSON.parse(JSON
            .stringify(this.goodFiles[listindex])) 
          this.imgfiles = [
            {
              id: this.goodFiles[listindex].id,
              icon_url: this.goodFiles[listindex].icon_url,
            },
          ]
        }
      }
      if (this.dialogshow) {
        return false
      }
      this.dialogshow = !this.dialogshow
    },
    clearform() {
      this.form = {
        name: '',
        icon_url: '',
        target_url: '',
        abstract: '',
      }
      this.resetForm()
      this.imgfiles = []
      this.updateid = 0
    },
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.form.icon_url) {
            let param = {}
            let apiname = ''
            const args = {
              name: this.form.name, //名称
              icon_url: this.form.icon_url, //图标
              target_url: this.form.target_url, //图标跳转地址
              abstract: this.form.abstract, //摘要
              goods_info: this.form.goods_info,
            }
            if (this.updateid) {
              apiname = 'updateMerchantList'
              param = Object.assign(
                args,
                {
                  id: this.updateid,
                }
              )
            } else {
              apiname = 'addMerchantList'
              param = Object.assign(
                args,
                {
                  page_id: this.produceId,
                  type: 2, //商家1 产地2
                  area_type: this.areatype,
                }
              )
            }
            merchant[apiname](param).then((res) => {
              if (res) {
                // 重新获取下数据
                this.getList()
                this.dialogshow = false
                Message.success({
                  message: '上传成功',
                })
              }
            })
          } else {
            Message.info({
              message: '请上传图片',
            })
          }
        }
      })
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
    },
    addfiles(e) {
      if (e) {
        this.imgfiles.push(e)
        this.$set(this.form, 'icon_url', e.icon_url)
      }
    },
    deletefiles(i) {
      this.imgfiles = []
      this.$set(this.form, 'icon_url', '')
    },
    getList() {
      merchant
        .getMerchantList({
          page_id: this.produceId, //产地id
          status: 0,
        })
        .then((res) => {
          if (res.status === 200 && res.data.data) {
            this.topFiles = res.data.data.filter(
              (item) => item.area_type === '3'
            )
            this.files = res.data.data.filter((item) => item.area_type === '1')
            this.bannerFiles = res.data.data.filter(
              (item) => item.area_type === '4'
            )
            this.goodFiles = res.data.data.filter(
              (item) => item.area_type == '5'
            ).sort((a, b) => {
              return Number(a.page_sort) - Number(b.page_sort)
            })
          }
        })
    },
    drag(e) {
      if (e.oldIndex == e.newIndex) {
        return false
      }
      let sort = {}
      for (let i = 0; i < this.goodFiles.length; i++) {
        const element = this.goodFiles[i];
        sort[element.id] = i
      }
      merchant['updateMerchantList']({
        id:+this.goodFiles[e.oldIndex].id,
        page_sort:sort
      }).then((res) => {
        if (res) {
          // 重新获取下数据
          this.getList()
          this.dialogshow = false
        }
      })
    },
    deleteItem(deleteid) {
      merchant.deleteMerchantList({ id: deleteid }).then((res) => {
        if (res) {
          Message.success({
            message: '删除成功',
          })
          this.getList()
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
.box-card {
  margin-top: 20px;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
  li {
    list-style: none;
    display: inline-block;
    text-align: center;
    width: 90px;
    //height: 90px;
    border-radius: 2px;
    margin-right: 20px;
    position: relative;
    img {
      width: 90px;
      height: 90px;
      border-radius: 2px;
    }
    .del_btn {
      position: absolute;
      z-index: 1;
      width: 20px;
      height: 20px;
      right: 2px;
      top: 2px;
      background: url(http://img.yimutian.com/crm/5d1c9ff47960423e111d01a2d8a0fcf9.png)
        no-repeat center center;
      background-size: 100%;
      cursor: pointer;
    }
    .galleryitem {
      text-align: center;
      > h5 {
        margin: 5px 0;
      }
      > p {
        margin-bottom: 0;
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .jingangitem {
    border: 1px dashed #b7b7b7;
    height: 90px;
    cursor: pointer;
    vertical-align: center;
    text-align: center;
    background: rgba(204, 204, 204, 0.3);
  }
}
.upload_area {
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 90px;
  height: 90px;
  background: #f2f2f2;
  border-radius: 2px;
  font-size: 12px;
  color: #333333;
  cursor: pointer;
  > img {
    width: 24px;
    height: 24px;
  }
}
.tip {
  color: #666;
  font-size: 12px;
}
</style>